export default __webpack_public_path__ + "static/edit_question-61c78b3d9dfd7ca6dd5c05e12382649d.mp4";